import { ASYNC_STATUS_ID } from 'constants'
import { API } from 'constants/apiEndPoints'
import { useEffect, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'

export const useHiLoRankingData = () => {
  const [rankingData, setRankingData] = useState([])
  const [rankingState, sendRankingQuery, hasRankingStatus] = useAPI(API.GAMES_HIGH_LWO_RANKINGS, {
    queryType: 'get',
    controlled: true,
    withJwt: true,
  })
  useEffect(() => {
    sendRankingQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (hasRankingStatus(ASYNC_STATUS_ID.ERROR)) console.log('ACZ: error', { rankingState })

    if (hasRankingStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const data = rankingState.data?.data?.rankings
      console.log('ACZ: rankingState', { rankingState })
      setRankingData(data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rankingState.status?.id, hasRankingStatus])
  return { rankingData }
}
